import api from '@/services/api';

const state = {
  orders: [],
  currentOrder: null,
  totalCount: 0
};

const getters = {
  getOrders: state => state.orders,
  getCurrentOrder: state => state.currentOrder,
  getTotalCount: state => state.totalCount
};

const mutations = {
  SET_ORDERS(state, { orders, totalCount }) {
    state.orders = orders;
    state.totalCount = totalCount;
  },
  SET_CURRENT_ORDER(state, order) {
    state.currentOrder = order;
  },
  ADD_ORDER(state, order) {
    state.orders.unshift(order);
  },
  UPDATE_ORDER(state, order) {
    const index = state.orders.findIndex(o => o.id === order.id);
    if (index > -1) {
      state.orders.splice(index, 1, order);
    }
  },
  DELETE_ORDER(state, orderId) {
    state.orders = state.orders.filter(o => o.id !== orderId);
  }
};

const actions = {
  async getOrders({ commit }, params) {
    try {
      const response = await api.get('/purchase-order', { params });
      commit('SET_ORDERS', { orders: response.data, totalCount: response.totalCount });
      return response;
    } catch (error) {
      console.error('获取订单列表失败:', error);
      throw error;
    }
  },
  async getOrderById({ commit }, orderId) {
    try {
      const response = await api.get(`/purchase-order/${orderId}`);
      commit('SET_CURRENT_ORDER', response.data);
      return response.data;
    } catch (error) {
      console.error('获取订单详情失败:', error);
      throw error;
    }
  },
  async createOrder({ commit }, orderData) {
    try {
      const response = await api.post('/purchase-order', orderData);
      commit('ADD_ORDER', response.data);
      return response.data;
    } catch (error) {
      console.error('创建订单失败:', error);
      throw error;
    }
  },
  async updateOrder({ commit }, { orderId, orderData }) {
    try {
      const response = await api.put(`/purchase-order/${orderId}`, orderData);
      commit('UPDATE_ORDER', response.data);
      return response.data;
    } catch (error) {
      console.error('更新订单失败:', error);
      throw error;
    }
  },
  async deleteOrder({ commit }, orderId) {
    try {
      await api.delete(`/purchase-order/${orderId}`);
      commit('DELETE_ORDER', orderId);
    } catch (error) {
      console.error('删除订单失败:', error);
      throw error;
    }
  },
  async getSellers() {
    try {
      const response = await api.get('/seller');
      return response.data;
    } catch (error) {
      console.error('获取卖家列表失败:', error);
      throw error;
    }
  },
  async getProductsBySeller(_, params) {
    try {
      const response = await api.get('/seller/products', { params });
      return response.data;
    } catch (error) {
      console.error('获取商品列表失败:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};